import { Capacitor } from '@capacitor/core'
import { breakpointsTailwind, useBreakpoints } from '@vueuse/core'

export const isMobile = useBreakpoints(breakpointsTailwind).smallerOrEqual('sm')
export const isAndroid = Capacitor.getPlatform() === 'android'
export const isIOS = Capacitor.getPlatform() === 'ios'
